import { pageInitializeSeoHandler, pageSeoSetCloseEditorHandler, pageSeoSetContentHandler, pageSeoSetFilterHandler, pageSeoUpdateHandler, pageSetSeoHandler } from '../actions';

export const usePageSeoState = (state, dispatch) => {
  const onEdit = (pageSeo) => {
    dispatch(pageSetSeoHandler(pageSeo));
  };

  const onInitialize = (languages) => {
    dispatch(pageInitializeSeoHandler(languages));
  };

  const onUpdateContent = (language, newContent) => {
    dispatch(pageSeoSetContentHandler(language, newContent));
  };

  const onCloseEditor = () => {
    dispatch(pageSeoSetCloseEditorHandler());
  };

  const onUpdateFilter = (filter, value) => {
    dispatch(pageSeoSetFilterHandler(filter, value));
  };
  const onUpdate = (pageSeo) => {
    dispatch(pageSeoUpdateHandler(pageSeo));
  };

  return {
    onEdit: (pageSeo) => onEdit(pageSeo),
    onUpdate: (pageSeo) => onUpdate(pageSeo),
    onInitialize: (languages) => onInitialize(languages),
    onUpdateContent: (language, newContent) => onUpdateContent(language, newContent),
    onCloseEditor: () => onCloseEditor(),
    onUpdateFilter: (filter, value) => onUpdateFilter(filter, value)
  };
};
